export const SHOW_ALERT_DIALOG = 'app/Dialogs/SHOW_ALERT_DIALOG'
export const ALERT_DIALOG_DISMISSED = 'app/Dialogs/ALERT_DIALOG_DISMISSED'
export const SHOW_CONFIRM_DIALOG = 'app/Dialogs/SHOW_CONFIRM_DIALOG'
export const CONFIRM_DIALOG_RESULT = 'app/Dialogs/CONFIRM_DIALOG_RESULT'
export const SHOW_PROMPT_DIALOG = 'app/Dialogs/SHOW_PROMPT_DIALOG'
export const PROMPT_DIALOG_RESULT = 'app/Dialogs/PROMPT_DIALOG_RESULT'
